export default "__VITE_ASSET__BnJL6agS__"